module.exports = __webpack_public_path__ + "img/appstore.f8ec50fa.svg";